const {Component} = require("react");
const PropTypes = require("prop-types");
const moment = require("moment");

class Time extends Component {

	static get propTypes() {
		return {
			from: PropTypes.string,
			to: PropTypes.string,
			interval: PropTypes.number,
			defaultValue: PropTypes.string,
			onChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			from: "00:00",
			to: "00:00",
			interval: 15,
		};
	}

	constructor(props) {
		super(props);
		const hourOptions = this.hourOptions(props.from, props.to);
		let hour = this.hourFromValue(props.defaultValue);

		if ((hour == undefined) && (hourOptions.length > 0)) {
			hour = hourOptions[0].value;
		}

		const minuteOptions = this.hourMinuteOptions(hour, props.from, props.to);
		let minute = this.minuteFromValue(props.defaultValue);

		if ((minute == undefined) && (minuteOptions.length > 0)) {
			minute = minuteOptions[0].value;
		}

		this.state = {
			hour,
			minute
		};
	}

	componentWillReceiveProps(nextProps) {
		if ((this.props.from !== nextProps.from) ||
			(this.props.to !== nextProps.to) ||
			(this.props.defaultValue !== nextProps.defaultValue)
		) {

			const hourOptions = this.hourOptions(nextProps.from, nextProps.to);
			let hour = this.hourFromValue(nextProps.defaultValue);

			if ((hour == undefined) && (hourOptions.length > 0)) {
				hour = hourOptions[0].value;
			}

			const minuteOptions = this.hourMinuteOptions(hour, nextProps.from, nextProps.to);
			let minute = this.minuteFromValue(nextProps.defaultValue);

			if ((minute == undefined) && (minuteOptions.length > 0)) {
				minute = minuteOptions[0].value;
			}

			this.setState({
				hour,
				minute
			});
		}
	}

	hourFromValue(value) {
		return value ? moment(value, "HH:mm:ss").hour() : null;
	}

	minuteFromValue(value) {
		return value ? moment(value, "HH:mm:ss").minute() : null;
	}

	hourOptions(fromTime, toTime) {
		let options = [];
		let current = moment(fromTime, "HH:mm");
		const to = moment(toTime, "HH:mm");

		while (current.hour() < to.hour()) {
			if (Math.ceil(current.minute() / this.props.interval) * this.props.interval < 60) {
				options.push({
					value: current.hour(),
					title: current.format("HH")
				});
			}

			current.add(1, "hour").minute(0);
		}

		return options;
	}

	hourMinuteOptions(hour, fromTime, toTime) {
		let options = [];
		const from = moment(fromTime, "HH:mm");
		let current = from.clone().hour(hour).minute(0);
		const startHour = current.hour();
		let value;

		if (from.hour() === current.hour()) {
			current.minute(from.minute()).add(
				Math.ceil(from.minute() / this.props.interval) * this.props.interval - from.minute(),
				"minute"
			);
		}

		while (current.hour() === startHour) {
			value = Math.ceil(current.minute() / this.props.interval) * this.props.interval;

			options.push({
				value: value,
				title: current.clone().minute(value).format("mm")
			});

			current.add(this.props.interval, "minute");
		}

		return options;
	}

	get currentHourOptions() {
		return this.hourOptions(this.props.from, this.props.to);
	}

	get currentMinuteOptions() {
		return this.hourMinuteOptions(this.state.hour, this.props.from, this.props.to);
	}

	get value() {
		return moment()
			.hour(this.state.hour)
			.minute(this.state.minute)
			.second(0)
			.format("HH:mm:ss");
	}

	onChange = () => {
		if (typeof this.props.onChange === "function") {
			this.props.onChange(this.value);
		}
	};

	onHourChange = (e) => {
		const from = moment(this.props.from, "HH:mm");
		const hour = parseInt(e.target.value);
		const minute = from.hour() === hour ?
			Math.ceil(from.minute() / this.props.interval) * this.props.interval :
			0;

		this.setState({
			hour,
			minute
		});

		return this.onChange();
	};

	onMinuteChange = (e) => {
		this.setState({
			minute: parseInt(e.target.value)
		});

		return this.onChange();
	};

	renderOptions(options) {
		return options.map(option => {
			return (<option key={option.value} value={option.value}>{option.title}</option>)
		});
	}

	render() {
		return (
			<div className="time-picker">
				<select ref={el => this.hourElement = el}
								onChange={this.onHourChange}
								value={this.state.hour}>{this.renderOptions(this.currentHourOptions)}</select>
				<select ref={el => this.minuteElement = el}
								onChange={this.onMinuteChange}
								value={this.state.minute}>{this.renderOptions(this.currentMinuteOptions)}</select>
			</div>
		);
	}

}

module.exports = Time;